export const CANVAS_WIDTH = 1366;
export const CANVAS_HEIGHT = 800;
export const CANVAS_BACKGROUND = "black";
export const PARTICLE_RADIUS = 5;
export const PARTICLE_GRAB_RADIUS = PARTICLE_RADIUS + 3;
export const PARTICLE_COLOR = "#FCE93D";
export const PARTICLE_COLOR_FOCUS = "#D9CB40";
export const SPRING_COLOR = "#FFFFFF";


